<template>
  <main class="main bundle-page product-page page-inside">
    <div class="main-wrapper">
      <section class="section hero-section">
        <div class="wrapper">
          <transition name="fade">
            <div class="product-preview" v-if="packInfo.id">
              <div class="preview-container">
                <div class="preview-wrapper">
                  <div class="preview">
                    <ImageGrid :images="imagePaths" :imgDomain="imgDomain"/>
                    <!--                    <div v-else class="doc-img">-->
                    <!--                      <img src="./../assets/doc.svg" class="img"/>-->
                    <!--                    </div>-->
                  </div>
                </div>
              </div>
              <div class="text">
                <div class="text-wrapper">
                  <div class="top">
                    <div class="row">
                      <div class="desc">{{ $t('Name') }}</div>
                      <div class="title">
                        <b>{{ packInfo.title }}</b>
                      </div>

                    </div>
<!--                    <div class="row" v-if="productPageItem.members_only == 1">-->
<!--                      <div class="title title-members">-->
<!--                        <img src="./../assets/member.svg" class="img"/>-->
<!--                        {{ $t('MEMBERS') }}-->
<!--                      </div>-->
<!--                    </div>-->
                    <div class="row">
                      <div class="desc">{{ $t('Description') }}</div>
                      <div class="desc" v-html="packInfo.description"></div>
                    </div>
                    <div class="row tags-row">
                      <div class="desc">{{ $t('Keywords') }}</div>
                      <div class="tags">
                        <router-link v-for="tag in tags" :key="tag.id"
                                     :to="`/bundle-list/images?filter[tag]=${tag.name}`"
                                     class="button tags__item">
                          {{ $t(tag.name) }}
                        </router-link>
                      </div>
                    </div>
                  </div>
                  <div class="bottom">
                    <div class="bottom-wrapper">
                      <div class="price">
                        <div class="price-title desc">{{ $t('Price') }}:</div>
                        <div class="price-value title">
                          {{ packInfo.price }}
                          <span class="currency">{{ $t(currency) }}</span>
                        </div>
                      </div>
                      <button class="button" @click="addToCart(packInfo, packInfo.id)">
<!--                        <span v-if="$parent.addToCartChosenItem == $parent.productPageItem.id">{{ $t('Added') }}</span>-->
                        <span>{{
                            $t('Add to cart')
                          }}</span>
                      </button>
                      <transition name="slide">
                        <div v-if="$parent.error" class="error-desc desc red">{{ $t($parent.error) }}</div>
                      </transition>
                    </div>
                  </div>
                  <div class="desc">
                    {{ $t('This is only a preview and not a real representation of the picture. After purchasing the product, you will be able to download it in the 1080x1080 quality, in format of PNG, JPEG or PDF and without watermarks') }}
                  </div>
                </div>
              </div>
            </div>
          </transition>
          <div class="inside">
            <div class="inside__title">
              What is inside:
            </div>
            <ImageBundleInside :currency="currency" :items="packItems"/>
          </div>
        </div>
      </section>
    </div>
  </main>
</template>

<script>
import ImageGrid from '../components/ImageGrid.vue';
import ImageBundleInside from "@/components/ImageBundleInside.vue";

export default {
  name: 'BundlePage',
  components: {
    ImageBundleInside,
    ImageGrid
  },
  props: ['currency'],
  data() {
    return {
      packInfo: {},
      packItems: [],
      imgDomain: process.env.VUE_APP_STATIC_DOMAIN,
      tag: '',
    }
  },
  watch: {
    currency(newVal) {
      console.log('Currency changed:', newVal);
      this.loadPackData();
    },
  },
  computed: {
    tags() {
      return this.packInfo.tags ? this.packInfo.tags : [];
    },
    keywords() {
      if (this.packInfo && this.packInfo.keywords) {
        return this.packInfo.keywords.split(",");
      }
      return [];
    },
    imagePaths() {
      return this.packItems.map(image => image.doc_url);
    }
  },
  mounted() {
    this.loadPackData();
  },
  methods: {
    async loadPackData() {
      const id = this.$route.params.id;

      try {
        // Получаем информацию о бандле
        const packInfoResponse = await this.$http.get(`${process.env.VUE_APP_API}packs/${id}/info`);
        this.packInfo = packInfoResponse.data.payload;

        // Получаем товары в бандле
        const packItemsResponse = await this.$http.get(`${process.env.VUE_APP_API}packs/${id}`);
        this.packItems = packItemsResponse.data.payload;

        // Подгружаем категорию для отображения
        const categoriesResponse = await this.$http.get(`${process.env.VUE_APP_API}categories`);
        const categories = categoriesResponse.data.payload;
        const tag = categories.find(cat => cat.id == this.packInfo.category_id);
        if (tag) {
          this.tag = tag.title;
        }

      } catch (error) {
        console.error('Ошибка при загрузке данных бандла:', error);
      }
    },
    addToCart(item, id) {
      this.$parent.addToCart(item, id, true);
    },
  }
}
</script>
